module.exports = __webpack_public_path__ + "static/media/closedBackgound.414b4a7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/closedBackgound.svg
// module id = 430
// module chunks = 0